<template>
  <div class="products-container">
    <individualProduct :product="product" v-for="product in products" />
  </div>
</template>
<script>
import individualProduct from "./individualProduct.vue"
export default {
  name: 'user-products',
  props: {
    products: Array
  },
  components: {
    individualProduct
  }
}
</script>
<style scoped>
.products-container {
  position: fixed;
  bottom: 0rem;
  height: 8rem;
  background-color: var(--light-gray);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 1rem 4rem 0rem 4rem;
}
</style>